import LoadScript from 'load-script';
import {RefObject} from 'react';
import {IMapsPlacesService} from '../Types/IMapAPI';
import {IPlace} from '../Types/IPlace';

let googlePlacesServicesInstance: IMapsPlacesService | null = null;

export const googleMapsApiLoader = (apiKey: string): Promise<boolean> => {

    return new Promise((resolve) => {
        if (typeof google === 'object' && typeof google.maps === 'object' && apiKey !== '') {
            resolve(true);
        } else {
            LoadScript(
                `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=geometry,places,drawing,visualization&v=quarterly`,
                (error: Error) => {
                    if (error) {
                        resolve(false);
                        return;
                    }

                    resolve(true);
                }
            );
        }
    });
}

export const initPlacesServices = (ref: RefObject<HTMLDivElement>): void => {
    googlePlacesServicesInstance = new google.maps.places.PlacesService(ref.current as HTMLDivElement);
}

export const getPlaceServices = (): IMapsPlacesService | null => googlePlacesServicesInstance;

export const getGoogleAutoSuggestion = (
    query: string
): Promise<any> => {
    const GoogleAutoCompleteService: google.maps.places.AutocompleteService = new google.maps.places.AutocompleteService();

    const requestOptions: { input: string; componentRestrictions: { country: string } } = {
        input: query,
        componentRestrictions: { country: 'AU' }
    };

    return new Promise((resolve, reject) => {
        GoogleAutoCompleteService.getPlacePredictions(requestOptions, (predictions, status) => {
            if (status === google.maps.places.PlacesServiceStatus.OK) {
                resolve(predictions);
            } else {
                reject(status);
            }
        });
    })
}

export const getPlaceFromCoordinate = (apiKey: string, lat: number, lng: number): Promise<IPlace> => {
    return new Promise<IPlace>((resolve, reject) => {
        fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}&result_type=locality|colloquial_area|point_of_interest|premise|airport`)
            .then((response: Response) => response.json())
            .then((data) => {
                if (data.status === google.maps.places.PlacesServiceStatus.OK && data.results.length > 0) {
                    const foundLocation = data.results.find((result) => {
                        return result.geometry.location.lat === lat && result.geometry.location.lng === lng;
                    });

                    if (typeof foundLocation !== 'undefined') {
                        resolve({
                            id: foundLocation.place_id,
                            latitude: foundLocation.geometry.location.lat,
                            longitude: foundLocation.geometry.location.lng,
                            isAirport: foundLocation.types.indexOf('airport') > -1,
                            name: foundLocation.formatted_address
                        });
                    } else {
                        reject(null)
                    }
                }
            })
            .catch((err) => reject(err));
    });
}
